import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=2ecbaf5e&scoped=true"
import script from "./ribbon.vue?vue&type=script&lang=ts"
export * from "./ribbon.vue?vue&type=script&lang=ts"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=2ecbaf5e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbaf5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecbaf5e')) {
      api.createRecord('2ecbaf5e', component.options)
    } else {
      api.reload('2ecbaf5e', component.options)
    }
    module.hot.accept("./ribbon.vue?vue&type=template&id=2ecbaf5e&scoped=true", function () {
      api.rerender('2ecbaf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selector-ribbon/ribbon.vue"
export default component.exports